import { useEffect, useRef } from 'react';
// @note: similar to useEffect, ignoring callback emit on mount
export var useOnDepsUpdate = function (callback, deps) {
    var isOnMountEmit = useRef(true);
    useEffect(function () {
        if (isOnMountEmit.current) {
            isOnMountEmit.current = false;
            return;
        }
        callback();
    }, deps);
};
